import { ClockIcon, LogOutIcon, MailIcon } from 'lucide-react';

import { useSession } from '@/components/auth/user-provider';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Shown to signed-in users whose role is still `pending` until an admin
 * assigns access. No staff navigation or app data is available here.
 */
export function AwaitingAccessPage() {
  const { session, signOut } = useSession();
  const name = session.status === 'signedIn' ? session.user.name : 'there';
  const email = session.status === 'signedIn' ? session.user.email : '';

  return (
    <div className="flex flex-1 items-center justify-center p-4 md:p-8">
      <Card className="border-border/80 w-full max-w-lg shadow-sm">
        <CardHeader className="items-center space-y-3 text-center">
          <span className="bg-muted text-foreground ring-border flex size-14 items-center justify-center rounded-2xl ring-1">
            <ClockIcon className="size-7" aria-hidden />
          </span>
          <CardTitle className="text-xl">Your account is awaiting access</CardTitle>
          <CardDescription className="text-base">
            Hi {name}. You have signed in successfully, but an administrator still needs to assign
            your role before you can use School Attendance.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          {email ? (
            <p className="text-muted-foreground flex items-center justify-center gap-2 text-sm">
              <MailIcon className="size-4 shrink-0" aria-hidden />
              <span className="truncate">{email}</span>
            </p>
          ) : null}
          <ul className="text-muted-foreground list-inside list-disc space-y-1 text-left text-sm">
            <li>Ask a school administrator to open Admin → Users</li>
            <li>They can set your role (teacher, parent, student, or admin)</li>
            <li>After they save, refresh this page to continue</li>
          </ul>
          <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
            <Button variant="outline" onClick={() => window.location.reload()}>
              Refresh
            </Button>
            <Button variant="default" onClick={() => signOut()}>
              <LogOutIcon /> Sign out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
